import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './supabase';
import Home from './pages/Home';
import MobileHome from './pages/MobileHome';
import RestaurantMenu from './pages/RestaurantMenu';
import MobileMenu from './pages/MobileMenu';
import EatIn from './pages/EatIn';
import Auth from './pages/Auth';

const isMobileDevice = () => window.innerWidth <= 768;

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mobile, setMobile] = useState(isMobileDevice);

  useEffect(() => {
    const handler = () => setMobile(isMobileDevice());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', background:'#fff' }}>
      <div style={{ fontFamily:'Inter', fontSize:'2rem', fontWeight: 800, background:'linear-gradient(135deg, #3a7d00, #1f4500)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>MacRO</div>
    </div>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={mobile ? <MobileHome user={user} /> : <Home user={user} />} />
        <Route path="/restaurant/:name" element={mobile ? <MobileMenu user={user} /> : <RestaurantMenu user={user} />} />
        <Route path="/eatin" element={<EatIn user={user} />} />
        <Route path="/auth" element={user ? <Navigate to="/" /> : <Auth />} />
      </Routes>
    </BrowserRouter>
  );
}
